<template>
  <div>
    <basic-container>
      <avue-crud
        :option="tableOption"
        :data="tableData"
        :table-loading="tableLoading"
        :page="page"
        ref="crud"
        @search-change="searchChange"
        @refresh-change="refreshChange"
        @row-save="handleSave"
        @row-update="handleUpdate"
        @selection-change="handleSelectionChange"
        @size-change="pageSizeChange"
        @current-change="pageChange"
      >

        <template
          slot-scope="scope"
          slot="menuLeft"
        >
          <!-- <el-button type="primary"
                               icon="el-icon-plus"
                               size="small"
                               plain
                               @click.stop="handleAdd()"
                    >新增
                    </el-button>
                    <el-button type="warning"
                               icon="el-icon-check"
                               size="small"
                               plain
                               @click.stop="handleDel('DELETE_OPTION','逻辑删除')">删除
                    </el-button>
                    <el-button type="danger"
                               icon="el-icon-check"
                               size="small"
                               plain
                               @click.stop="handleDel('DELETE_OPTION','物理删除')">物理删除
                    </el-button> -->
        </template>
        <template
          slot-scope="scope"
          slot="menu"
        >
          <!--<el-button type="primary"-->
          <!--icon="el-icon-check"-->
          <!--size="small"-->
          <!--plain-->
          <!--@click.stop="handleEdit(scope.row,scope.index)"-->
          <!--&gt;编辑-->
          <!--</el-button>-->
          <el-button
            type="success"
            icon="el-icon-check"
            size="small"
            plain
            @click.stop="open()"
          >查看明细
          </el-button>
          <el-button
            type="success"
            icon="el-icon-view"
            size="small"
            plain
            @click.stop="immediatePayment(scope.row.id)"
            v-if="scope.row.status=='WAIT_PAY'"
          >立即付款</el-button>
        </template>
        <template
          slot-scope="scope"
          slot="status"
        >
          <el-tag
            v-for="obj of redPacketStatus"
            :key="obj.value"
            v-if="obj.value == scope.row.status"
          >
            {{obj.label}}
          </el-tag>
        </template>
      </avue-crud>
      <template>
        <el-dialog
          title="红包明细"
          :visible.sync="detailVisible"
        >
          <el-form
            :inline="true"
            :model="detailSearch"
            label-width="80px"
            size="small"
          >
            <el-form-item
              label="红包状态"
              :span="6"
            >
              <el-select
                v-model="detailSearch.status"
                required
                value-key="value"
              >
                <el-option
                  v-for="status in detailStatusList"
                  :key="status.value"
                  :label="status.label"
                  :value="status"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="领取时间"
              :span="12"
            >
              <el-date-picker
                v-model="detailSearch.startTime_endTime"
                type="daterange"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :default-time="['00:00:00', '23:59:59']"
                value-format="timestamp"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item :span="6">
              <el-button
                class="el-button el-button--primary el-button--small"
                @click.stop="handleDetailSearch()"
              >
                <i class="el-icon-search"></i>
                搜索
              </el-button>
            </el-form-item>
          </el-form>

          <el-table
            :data="detailData"
            border
          >
            <el-table-column
              property="realName"
              label="领取人姓名"
              width="200"
              sortable
            >
            </el-table-column>
            <el-table-column
              property="quota"
              label="金额"
              width="100"
              sortable
            >
            </el-table-column>
            <el-table-column
              property="status"
              label="状态"
              sortable
              :formatter="formatterStatus"
            >
            </el-table-column>
            <el-table-column
              property="collectionTime"
              label="领取时间"
              sortable
              :formatter="formatterTime"
            >
            </el-table-column>
          </el-table>
          <el-pagination
            @size-change="handleDetailSizeChange"
            @current-change="handleDetailCurrentChange"
            :current-page="detailPage.currentPage"
            layout="total, sizes, prev, pager, next, jumper"
            :page-sizes="[10, 50, 100, 200]"
            :page-size="detailPage.pageSize"
            :total="detailPage.total"
          >
          </el-pagination>
        </el-dialog>
      </template>
      <template>
        <el-dialog
          title="二维码支付"
          :visible.sync="QRCodeDialog"
          align="center"
        >
          <vue-qr
            :text="config.value"
            :size="200"
          ></vue-qr>
          <el-button @click="QRCodeDialog = false">关闭</el-button>
        </el-dialog>
      </template>
    </basic-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { redPacketTableOption } from "@/const/salesCloud/redPacketOption";
import {
  findRedPacket,
  addRedPacket,
  editRedPacket,
  immediatePay,
  delRedPacket,
  findRedPacketDetail,
} from "@/api/salesCloud/redPacket";
import { findByLabel, formatterTime, resolveUrlPath } from "@/util/util";
import { DIC } from "@/const/dic";
import VueQr from "vue-qr";
export default {
  name: "redPacket",
  components: {
    VueQr,
  },
  data() {
    return {
      tableOption: redPacketTableOption, //表格设置属性
      tableData: [], //表格的数据
      tablePage: 1,
      tableLoading: false,
      tabelObj: {},
      page: {
        total: 0, //总页数
        currentPage: 1, //当前页数
        pageSize: 10, //每页显示多少条
      },
      grade: {
        box: false,
        check: [],
      },
      detailVisible: false,
      detailData: [],
      selectRedPacket: {},
      detailSearch: {},
      detailPage: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
      },
      detailStatusList: DIC.SALES_RED_PACKED_DETAIL_STATUS,
      redPacketStatus: DIC.SALES_RED_PACKED_STATUS,
      QRCodeDialog: false,
      config: {},
    };
  },
  created() {
    this.handleList();
  },
  watch: {},
  mounted() {},
  computed: {
    ...mapGetters(["permission"]),
  },
  props: [],
  methods: {
    handleDetailSearch() {
      let params = new Object();
      (params.page = this.detailPage.currentPage),
        (params.size = this.detailPage.pageSize);
      params.redPacketId = this.selectRedPacket.id;
      params.status = this.detailSearch.status.value;
      if (
        null != this.detailSearch.startTime_endTime &&
        undefined != this.detailSearch.startTime_endTime
      ) {
        params.startTime = this.detailSearch.startTime_endTime[0];
        params.endTime = this.detailSearch.startTime_endTime[1];
      }
      findRedPacketDetail(params).then((res) => {
        let data = JSON.parse(res.data);
        this.detailData = data.rows;
        this.detailPage = {
          total: data.total,
          currentPage: this.detailPage.currentPage,
          pageSize: this.detailPage.pageSize,
        };
      });
    },
    handleDetailSizeChange(pageSize) {
      let params = new Object();
      (params.page = this.detailPage.currentPage), (params.size = pageSize);
      params.redPacketId = this.selectRedPacket.id;
      if (
        null != this.detailSearch.startTime_endTime &&
        undefined != this.detailSearch.startTime_endTime
      ) {
        params.startTime = this.detailSearch.startTime_endTime[0];
        params.endTime = this.detailSearch.startTime_endTime[1];
      }
      findRedPacketDetail(params).then((res) => {
        let data = JSON.parse(res.data);
        this.detailData = data.rows;
        this.detailPage = {
          total: data.total,
          currentPage: this.detailPage.currentPage,
          pageSize: pageSize,
        };
      });
    },
    handleDetailCurrentChange(page) {
      let params = new Object();
      (params.page = page), (params.size = this.detailPage.pageSize);
      params.redPacketId = this.selectRedPacket.id;
      if (
        null != this.detailSearch.startTime_endTime &&
        undefined != this.detailSearch.startTime_endTime
      ) {
        params.startTime = this.detailSearch.startTime_endTime[0];
        params.endTime = this.detailSearch.startTime_endTime[1];
      }
      findRedPacketDetail(params).then((res) => {
        let data = JSON.parse(res.data);
        this.detailData = data.rows;
        this.detailPage = {
          total: data.total,
          currentPage: page,
          pageSize: this.detailPage.pageSize,
        };
      });
    },
    formatterStatus(row, column) {
      for (let i = 0; i < this.detailStatusList.length; i++) {
        if (this.detailStatusList[i].value == row.status)
          return this.detailStatusList[i].label;
      }
    },
    formatterTime(row, column) {
      if (null != row.collectionTime) {
        return formatterTime(row.collectionTime);
      }
      return "";
    },
    handleDetail(row, index) {
      this.selectRedPacket = row;
      this.detailVisible = true;
      let parmas = {
        redPacketId: row.id,
        page: this.detailPage.currentPage,
        size: this.detailPage.pageSize,
      };
      findRedPacketDetail(parmas).then((res) => {
        let data = JSON.parse(res.data);
        this.detailData = data.rows;
        this.detailPage = {
          total: data.total,
          currentPage: this.detailPage.currentPage,
          pageSize: this.detailPage.pageSize,
        };
      });
    },
    pageSizeChange(pageSize) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      (params.page = this.page.currentPage), (params.size = pageSize);
      findRedPacket(params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: pageSize,
        };
        this.tableLoading = false;
      });
    },
    pageChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = page;
      params.size = this.page.pageSize;
      findRedPacket(params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: page,
          pageSize: this.page.pageSize,
        };
        this.tableLoading = false;
      });
    },
    searchChange(params) {
      this.tableLoading = true;
      // let params = this.$refs.crud.searchForm
      params.page = this.page.currentPage;
      params.size = this.page.pageSize;
      findRedPacket(params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: params.page,
          pageSize: params.size,
        };
        this.tableLoading = false;
      });
    },
    refreshChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = page.currentPage;
      params.size = page.pageSize;
      findRedPacket(params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: page.currentPage,
          pageSize: page.pageSize,
        };
        this.tableLoading = false;
      });
    },
    /**
     * @title 打开新增窗口
     * @detail 调用crud的handleadd方法即可
     *
     **/
    handleAdd() {
      this.$refs.crud.rowAdd();
    },
    handleEdit(row, index) {
      if (
        null != row.startDate &&
        undefined != row.startDate &&
        null != row.endDate &&
        undefined != row.endDate
      ) {
        let time = new Array();
        time.push(row.startDate);
        time.push(row.endDate);
        row.startDate_endDate = time;
      }
      this.$refs.crud.rowEdit(row, index);
    },
    /**
     * @title 获取数据
     * @detail 赋值为tableData表格即可
     *
     **/
    handleList() {
      this.tableLoading = true;
      let parmas = {
        page: this.page.currentPage,
        size: this.page.pageSize,
      };
      findRedPacket(parmas).then((res) => {
        console.log(res);
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: this.page.pageSize,
        };
        this.tableLoading = false;
      });
    },
    /**
     * @title 数据添加
     * @param row 为当前的数据
     * @param done 为表单关闭函数
     *
     **/
    handleSave(row, done) {
      if (null != row.startDate_endDate && undefined != row.startDate_endDate) {
        row.startDate = row.startDate_endDate[0];
        row.endDate = row.startDate_endDate[1];
      }
      addRedPacket(row)
        .then((response) => {
          if (response.code == "200") {
            this.$message({
              showClose: true,
              message: "添加成功",
              type: "success",
            });
            this.handleList();
          } else {
            this.$message({
              showClose: true,
              message: response.message,
              type: "error",
            });
          }
        })
        .catch((error) => {
          this.loading = false;
          this.$message({
            showClose: true,
            message: error,
            type: "error",
          });
        });
      done();
    },
    /**
     * @title 当前选中的数据
     * @param val 选中的值
     *
     **/
    handleSelectionChange() {
      // console.log(val);
      // this.tableRow = val;
      // this.$notify({
      //     showClose: true,
      //     message: JSON.stringify(val),
      //     type: 'success',
      // });
    },
    /**
     * @title 数据删除
     * @param row 为当前的数据
     * @param index 为当前更新数据的行数
     *
     **/
    handleDel(dicName, label) {
      if (this.$refs.crud.tableSelect.length == 0) {
        this.$message({
          showClose: true,
          message: "请选择要操作的数据",
          type: "error",
        });
        return;
      }

      this.$confirm(`是否确认删除?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let ids = new Array();
          for (let row of this.$refs.crud.tableSelect) {
            ids.push(row.id);
          }

          delRedPacket(findByLabel(DIC.DELETE_OPTION, label), ids)
            .then((response) => {
              if (response.code == "200") {
                this.$message({
                  showClose: true,
                  message: "删除成功",
                  type: "success",
                });
                this.handleList();
              } else {
                this.$message({
                  showClose: true,
                  message: response.message,
                  type: "error",
                });
              }
            })
            .catch((error) => {
              this.loading = false;
              this.$message({
                showClose: true,
                message: error,
                type: "error",
              });
            });
        })
        .catch(() => {});
    },
    /**
     * @title 数据更新
     * @param row 为当前的数据
     * @param index 为当前更新数据的行数
     * @param done 为表单关闭函数
     *
     **/
    handleUpdate(row, index, done) {
      if (null != row.startDate_endDate && undefined != row.startDate_endDate) {
        row.startDate = row.startDate_endDate[0];
        row.endDate = row.startDate_endDate[1];
      }
      editRedPacket(row)
        .then((response) => {
          if (response.code == "200") {
            this.$message({
              showClose: true,
              message: "添加成功",
              type: "success",
            });
            this.handleList();
          } else {
            this.$message({
              showClose: true,
              message: response.message,
              type: "error",
            });
          }
        })
        .catch((error) => {
          this.loading = false;
          this.$message({
            showClose: true,
            message: error,
            type: "error",
          });
        });
      done();
    },
    immediatePayment(id) {
      let data = {};
      data.redPacketId = id;
      immediatePay(data).then((res) => {
        console.log("集合：" + JSON.stringify(res.data));
        // let data = JSON.parse(res.data);
        this.config.value = res.data.codeUrl;
        this.QRCodeDialog = true;
      });
    },
    open() {
      this.$router.push({ path: "/salesCloud/redPacket" });
      // let routeData = this.$router.resolve({ path: '/salesCloud/redPacket', query: { id: 1  } });
      // window.open(routeData.href, '_blank');
      // let item={"id":61,"code":null,"label":"红包管理","icon":"icon","permissionValue":"JOINS_SALES_REDPACKET","href":"/salesCloud/redPacket","orders":57,"pid":60,"type":"MENU","systemId":null,"children":null}
      // this.$router.push({
      //     path: resolveUrlPath('/salesCloud/redPacket', '红包明细'),
      //     query: item.query
      // })
    },
  },
};
</script>

<style lang="scss">
.table-container {
  padding: 8px 10px;
}

.demo-table-expand {
  font-size: 0;
}

.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}

.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
</style>
